// import Income from "@/utilities/classes/income";
// import Taxes from "@/utilities/classes/taxes";
export default class Tenant {
  constructor(_id, _FirstName, _LastName, _Race,_Ethnicity, _DateOfBirth, _Incomes, _GrossTaxes, _HasTaxes, _CreditReport, _ID, _TaxReturn, _HasIncome, _ZeroIncomeCert, _TotalIncome) {
    this.id = _id;
    this.FirstName = _FirstName;
    this.LastName = _LastName;
    this.Race = _Race;
    this.Ethnicity = _Ethnicity;
    this.DateOfBirth = _DateOfBirth;
    this.Incomes = [];
    this.GrossTaxes = _GrossTaxes;
    this.HasTaxes = _HasTaxes;
    this.CreditReport = [];
    this.ID = [];
    this.TaxReturn = [];
    this.HasIncome = _HasIncome
    this.ZeroIncomeCert = [];
    this.TotalIncome = _TotalIncome;
  }
}
